var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSz = function SvgSz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0ee6f58a-4cf2-4bc6-9b05-c1de27db1b60a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "083f4ed1-b1b3-4451-9cf0-f8928fad3ec4b",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#083f4ed1-b1b3-4451-9cf0-f8928fad3ec4b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDE00",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4769C1",
    fillRule: "evenodd",
    d: "M0 12h21v3H0zM0 0h21v3H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BC0A33",
    fillRule: "evenodd",
    d: "M0 4h21v7H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1C400",
    fillRule: "evenodd",
    d: "M4 8h13v1H4zm2-2h10v1H6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D9191",
    fillRule: "evenodd",
    d: "M16 6h2v1h-2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.5 10c2.485 0 4.5-2.5 4.5-2.5S12.985 5 10.5 5 6 7.5 6 7.5 8.015 10 10.5 10",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10.5 10C11 10 12 7.5 12 7.5S11 5 10.5 5C8.015 5 6 7.5 6 7.5S8.015 10 10.5 10",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#878787",
    fillRule: "evenodd",
    d: "M8 7h1v1H8zm2 0h1v1h-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B5B5B",
    fillRule: "evenodd",
    stroke: "#979797",
    d: "M13 7h1v1h-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0ee6f58a-4cf2-4bc6-9b05-c1de27db1b60a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgSz;